<template>
  <div class="shops-nav hidden-lg-and-down">
    <div class="information">
<!--      <div class="information-title">店铺名称：{{company_info.name}}</div>-->
<!--      <div class="information-label">技能标签：<p v-for="(item,index) of company_info.skill" :key="index">-->
<!--        {{item.tag_value}}</p></div>-->
<!--      <div class="information-division"></div>-->
<!--      <div class="information-name">用户名：{{company_info.name}}</div>-->
<!--      <div class="information-name">联系方式：{{company_info.mobile}}</div>-->
<!--      <div class="information-name">经营模式：股份有限公司</div>-->
<!--      <div class="information-name">所在区域：{{company_info.auth_info.contact_addr}}</div>-->
    </div>
    <div class="classification"></div>
  </div>
</template>
<script>
    export default {
        data() {
            return {
                company_info: '',
            }
        },
        methods() {

        },
        created() {
            var url = window.config.api_url + '/college/shop/info?id=' + this.$route.params.id
            this.axios.get(url).then(res => {
                this.company_info = res.data
                console.log(res.data)
                this.company_info = res.data
            })
        }
    }
</script>
<style lang="less">

  .shops-nav {
    .information {
      position: fixed;
      margin-left: 5px;
      width: 175px;
      background: #FFFFFF;
      border-radius: 10px;

      .information-title {
        margin-left: 15px;
        margin-top: 10px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
      }

      .information-label {
        margin-left: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        //line-height: 10px;
      }

      .information-division {
        width: 100%;
        height: 1px;
        background: #DADFE7;
        border-radius: 1px;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      .information-name {
        margin-left: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
      }
    }

    .classification {

    }
  }
</style>